import script from "./EvReport.vue?vue&type=script&setup=true&lang=js"
export * from "./EvReport.vue?vue&type=script&setup=true&lang=js"

import "./EvReport.vue?vue&type=style&index=0&id=17bfbc7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17bfbc7e"]])

export default __exports__